<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Cadastrar um Local</h3>
                 </b-col>
                 <b-col md="3" v-if="!perfilAdmin">
                    <p><b>Nome:</b> {{usuario.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
           <b-form>
             <b-row v-if="perfilAdmin">
                <b-col sm="6">
                    <b-form-group label="UF:">
                        <b-form-select v-model="$v.form.uf.$model" :options="estados" :state="chkState('uf')" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input1LiveFeedback5">UF é obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Município:" :disabled="disabled_cidades">
                        <b-form-select
                                v-model="$v.form.municipio.$model"
                                :options="cidades"
                                :state="chkState('municipio')">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input1LiveFeedback5">Município é obrigatório.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
               <b-col cols="6">
                    <b-form-group label="Nome do local:">
                         <b-input-group class="mb-3">
                             <b-input-group-prepend>
                                 <b-input-group-text><i class="fa fa-id-badge"
                                                        aria-hidden="true"></i></b-input-group-text>
                             </b-input-group-prepend>
                             <b-form-input type="text"
                                           class="form-control"
                                           placeholder="Nome do local"
                                           autocomplete="nome"
                                           v-model.trim="$v.form.local.$model"
                                           :state="chkState('local')"/>
                             <b-form-invalid-feedback id="input1LiveFeedback3">Nome do local é obrigatório.
                             </b-form-invalid-feedback>
                         </b-input-group>
                     </b-form-group>
              </b-col>
                <b-col cols="6">
                <b-form-group label="Categoria do local:">
                    <b-form-select class="mb-3"  v-model="$v.form.categoria.$model" :state="chkState('categoria')" :options="categorias">
                        <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback5">Categoria é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
                <b-col cols="6">
                    <b-form-group label="Endereço completo:">
                         <b-input-group class="mb-3">
                             <b-input-group-prepend>
                                 <b-input-group-text><i class="fa fa-id-badge"
                                                        aria-hidden="true"></i></b-input-group-text>
                             </b-input-group-prepend>
                             <b-form-input type="text"
                                           class="form-control"
                                           placeholder="Endereço completo"
                                           autocomplete="nome"
                                           v-model.trim="$v.form.endereco.$model"
                                           :state="chkState('endereco')"/>
                             <b-form-invalid-feedback id="input1LiveFeedback3">Endereço completo é obrigatório.
                             </b-form-invalid-feedback>
                         </b-input-group>
                     </b-form-group>
                </b-col>
                <b-col cols="4">
                <b-form-group label="CEP">
                     <b-input-group class="mb-3">
                         <b-input-group-prepend>
                             <b-input-group-text><i class="fa fa-address-card"
                                                    aria-hidden="true"></i></b-input-group-text>
                         </b-input-group-prepend>
                         <b-form-input type="text"
                                       v-mask="'#####-###'"
                                       class="form-control"
                                       placeholder="CEP"
                                       autocomplete="cep"
                                       v-model.lazy.trim="$v.form.cep.$model"
                                       :state="chkState('cep')"/>
                         <b-form-invalid-feedback
                                 id="input1LiveFeedback3">CEP é obrigatório.</b-form-invalid-feedback>
                     </b-input-group>
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group label="Referência:">
                  <b-input-group class="mb-3">
                         <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-user-secret"></i></b-input-group-text>
                    </b-input-group-prepend>
                   <b-form-textarea id="textarea" rows="3" max-rows="6" v-model.lazy.trim="$v.form.referencia.$model"></b-form-textarea>
                      <b-form-invalid-feedback id="input1LiveFeedback2">Referência é obrigatória</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
            <b-button variant="primary" @click="onSubmit"><i class="fa fa-check"></i> Salvar</b-button>
            <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import {validationMixin} from 'vuelidate'
import {required, requiredIf, minLength} from 'vuelidate/lib/validators'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  local: '',
  categoria: null,
  endereco: null,
  cep: null,
  lotacao_maxima: null,
  referencia: '',
  uf: null,
  municipio: null
}

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      uf: {
        required: requiredIf(function () {
          if (this.perfilAdmin) {
            return true
          }
          return false
        })
      },
      municipio: {
        required: requiredIf(function () {
          if (this.perfilAdmin) {
            return true
          }
          return false
        })
      },
      local: {
        required
      },
      categoria: {
        required
      },
      endereco: {
        required
      },
      cep: {
        required,
        minLength: minLength(9)
      },
      referencia: {
        // required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('buscarEstados')
      this.perfilAdmin = true
    }
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' ||
          SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L' ||
          SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.$store.dispatch('buscarCategorias')
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      disabled_cidades: true,
      perfilAdmin: false,
      form: Object.assign({}, formShape),
      salvarForm: false,
      ocupacoes: [],
      ocupacao: {
        periodo: '',
        dia: ''
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: ''
      }
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    categorias () {
      return this.$store.state.categoria.listaCategorias
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    'usuario.dados_pessoais.cidade': function () {
      this.usuarioLogado.municipio = this.usuario.dados_pessoais.cidade.cidade
    },
    'usuario.dados_pessoais.cidade.estado': function () {
      this.usuarioLogado.estado = this.usuario.dados_pessoais.cidade.estado.estado
    },
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    },
    '$v.form.uf.$model': function () {
      if (this.$v.form.uf.$model !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.$v.form.uf.$model)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.$v.form.municipio.$model = null
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    save () {
      let form = this.$v.form
      let data = {
        local: form.local.$model,
        categoria: form.categoria.$model,
        usuario_id: SessionStorage.get('usuario'),
        endereco: form.endereco.$model,
        cep: form.cep.$model.replace(/[^\d]+/g, ''),
        referencia: form.referencia.$model,
        municipio_id: form.municipio.$model
      }

      if (this.ocupacoes.length) {
        data.ocupacoes = this.ocupacoes
      }

      /* console.log(data)
      return */

      Vue.http.post('api/local', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push('/locais')
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Erro!', 7000)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Confirma o cadastro do local?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.save()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true

      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]

      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    adicionaMascara: function (numero) {
      if (numero.toString().length === 4) {
        var b = '.'
        var position = 1
        var output = [numero.slice(0, position), b, numero.slice(position)].join('')
        this.$v.form.lotacao_maxima.$model = output
      }
    },

    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      if (this.$v.form.local.$model.length > 200) {
        this.erro('Limite do nome do local é de 200 caracteres.')
        return false
      }
      if (this.$v.form.endereco.$model.length > 200) {
        this.erro('Limite do endereço é de 200 caracteres.')
        return false
      }
      return this.isValid
    },
    erro (msg) {
      miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
      miniToastr.error(msg, 'Alerta!', 5000)
    },
    ocupar (dia, periodo) {
      this.adicionarOcupacao(dia, periodo)
      this.ajustarTexto(dia, periodo)
    },
    adicionarOcupacao: function (dia, periodo) {
      let adicionar = true

      for (let i = 0; i < this.ocupacoes.length; i++) {
        if (this.ocupacoes[i].dia === dia && this.ocupacoes[i].periodo === periodo) {
          this.ocupacoes.splice(i, 1)
          adicionar = false
        }
      }

      if (adicionar) {
        this.ocupacoes.push(Vue.util.extend({}, {dia: dia, periodo: periodo}))
      }
    },
    ajustarTexto: function (dia, periodo) {
      if (periodo === 'MANHA') {
        switch (dia) {
          case 'SEGUNDA':
            if (!this.semanaManha.segunda) {
              this.semanaManha.segunda = 'Sim'
            } else {
              this.semanaManha.segunda = ''
            }

            return
          case 'TERCA':
            if (!this.semanaManha.terca) {
              this.semanaManha.terca = 'Sim'
            } else {
              this.semanaManha.terca = ''
            }

            return
          case 'QUARTA':
            if (!this.semanaManha.quarta) {
              this.semanaManha.quarta = 'Sim'
            } else {
              this.semanaManha.quarta = ''
            }
            return
          case 'QUINTA':
            if (!this.semanaManha.quinta) {
              this.semanaManha.quinta = 'Sim'
            } else {
              this.semanaManha.quinta = ''
            }
            return
          case 'SEXTA':
            if (!this.semanaManha.sexta) {
              this.semanaManha.sexta = 'Sim'
            } else {
              this.semanaManha.sexta = ''
            }
            return
          case 'SABADO':
            if (!this.semanaManha.sabado) {
              this.semanaManha.sabado = 'Sim'
            } else {
              this.semanaManha.sabado = ''
            }
            return
          case 'DOMINGO':
            if (!this.semanaManha.domingo) {
              this.semanaManha.domingo = 'Sim'
            } else {
              this.semanaManha.domingo = ''
            }
            return
          default:
            return ''
        }
      }

      if (periodo === 'TARDE') {
        switch (dia) {
          case 'SEGUNDA':
            if (!this.semanaTarde.segunda) {
              this.semanaTarde.segunda = 'Sim'
            } else {
              this.semanaTarde.segunda = ''
            }

            return
          case 'TERCA':
            if (!this.semanaTarde.terca) {
              this.semanaTarde.terca = 'Sim'
            } else {
              this.semanaTarde.terca = ''
            }

            return
          case 'QUARTA':
            if (!this.semanaTarde.quarta) {
              this.semanaTarde.quarta = 'Sim'
            } else {
              this.semanaTarde.quarta = ''
            }
            return
          case 'QUINTA':
            if (!this.semanaTarde.quinta) {
              this.semanaTarde.quinta = 'Sim'
            } else {
              this.semanaTarde.quinta = ''
            }
            return
          case 'SEXTA':
            if (!this.semanaTarde.sexta) {
              this.semanaTarde.sexta = 'Sim'
            } else {
              this.semanaTarde.sexta = ''
            }
            return
          case 'SABADO':
            if (!this.semanaTarde.sabado) {
              this.semanaTarde.sabado = 'Sim'
            } else {
              this.semanaTarde.sabado = ''
            }
            return
          case 'DOMINGO':
            if (!this.semanaTarde.domingo) {
              this.semanaTarde.domingo = 'Sim'
            } else {
              this.semanaTarde.domingo = ''
            }
            return
          default:
            return ''
        }
      }

      if (periodo === 'NOITE') {
        switch (dia) {
          case 'SEGUNDA':
            if (!this.semanaNoite.segunda) {
              this.semanaNoite.segunda = 'Sim'
            } else {
              this.semanaNoite.segunda = ''
            }

            return
          case 'TERCA':
            if (!this.semanaNoite.terca) {
              this.semanaNoite.terca = 'Sim'
            } else {
              this.semanaNoite.terca = ''
            }

            return
          case 'QUARTA':
            if (!this.semanaNoite.quarta) {
              this.semanaNoite.quarta = 'Sim'
            } else {
              this.semanaNoite.quarta = ''
            }
            return
          case 'QUINTA':
            if (!this.semanaNoite.quinta) {
              this.semanaNoite.quinta = 'Sim'
            } else {
              this.semanaNoite.quinta = ''
            }
            return
          case 'SEXTA':
            if (!this.semanaNoite.sexta) {
              this.semanaNoite.sexta = 'Sim'
            } else {
              this.semanaNoite.sexta = ''
            }
            return
          case 'SABADO':
            if (!this.semanaNoite.sabado) {
              this.semanaNoite.sabado = 'Sim'
            } else {
              this.semanaNoite.sabado = ''
            }
            return
          case 'DOMINGO':
            if (!this.semanaNoite.domingo) {
              this.semanaNoite.domingo = 'Sim'
            } else {
              this.semanaNoite.domingo = ''
            }
            return
          default:
            return ''
        }
      }
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/locais/LocalCadastrar.vue